import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import '../../CSS/Global.css';
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import axios from 'axios'
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import { decryptToken } from "../utils/getToken";

// utils/calcAmount.js
export const getRowAmount = (row, editMode = false) => {
    const { quantity, rate, discount, tax, amount } = row;

    const userEdited =
        quantity || rate || discount || tax; // detect if user touched fields

    if (!userEdited && editMode && amount !== undefined && amount !== null && amount !== "") {
        // ✅ Trust backend amount only when editing existing invoice and no fields touched
        return parseFloat(amount).toFixed(2);
    }

    // ✅ Otherwise recalc dynamically
    return (
        (parseFloat(quantity) || 0) *
        (parseFloat(rate) || 0) *
        (1 - (parseFloat(discount) || 0) / 100) *
        (1 + (parseFloat(tax) || 0) / 100)
    ).toFixed(2);
};




const ItemTable = ({ items, setItems, setSubtotal, itemsOptions, setItemsOptions }) => {
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    // const [itemsOptions, setItemsOptions] = useState([]);
    const [showVariationModal, setShowVariationModal] = useState(false);
    const [currentVariableProduct, setCurrentVariableProduct] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const token = decryptToken("accessToken") || ""

    const fetchServiceData = async () => {
        try {
            const response = await axios.get(
                `${url}/grouped-product/search-all-products/${isLoggedIn.main_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            const productOptions = response.data.map(product => {
                let variation = [];

                if (product.variation) {
                    if (typeof product.variation === "string") {
                        try {
                            variation = JSON.parse(product.variation);
                        } catch (e) {
                            console.error("Invalid variation JSON:", product.variation);
                            variation = [];
                        }
                    } else {
                        // already object/array
                        variation = product.variation;
                    }
                }

                return {
                    label: product.title,
                    value: {
                        id: product.id,
                        title: product.title,
                        hsn: product.hsn,
                        product_type: product.product_type,
                        salePrice: product.salePrice,
                        discountPrice: product.discountPrice,
                        sku: product.sku || product.product_id,
                        variation
                    }
                };
            });

            console.log(productOptions)
            setItemsOptions(productOptions);

        } catch (error) {
            console.log("Fetch error:", error);
        }
    };



    const handleInputChange = (id, field, value) => {
        if (field === "item") {
            // Variable Product: Open modal
            if (value.product_type === "Variable Product") {
                setCurrentVariableProduct(value);
                setSelectedRowId(id);
                setShowVariationModal(true);
                return;
            }

            // ✅ Non-variable: Set rate directly
            const updatedRows = items.map(row =>
                row.id === id
                    ? {
                        ...row,
                        item: { title: `${value.title} - ${value.sku}` },
                        rate: value.discountPrice || value.salePrice || "",
                        quantity: row.quantity && parseFloat(row.quantity) > 0 ? row.quantity : "1",
                        hsn: value.hsn || ""
                    }
                    : row
            );
            setItems(updatedRows);
            recalculateSubtotal(updatedRows);
            return;
        }

        // Handle other fields (quantity, rate, etc.)
        const updatedRows = items.map(row =>
            row.id === id ? { ...row, [field]: value } : row
        );
        setItems(updatedRows);
        recalculateSubtotal(updatedRows);
    };


    const recalculateSubtotal = (updatedItems) => {
        console.log(updatedItems)
        const newSubtotal = updatedItems.reduce((acc, row) => {
            const qty = parseFloat(row.quantity) || 0;
            const rate = parseFloat(row.rate) || 0;
            const discount = parseFloat(row.discount) || 0;
            const tax = parseFloat(row.tax) || 0;
            return acc + qty * rate * (1 - discount / 100) * (1 + tax / 100);
        }, 0);
        setSubtotal(newSubtotal);
    };


    const handleAddRow = () => {
        setItems([
            ...items,
            { id: uuidv4(), item: null, quantity: "1", rate: "", discount: "", tax: "", hsn: "" },
        ]);
    };

    const handleDeleteRow = (id) => {
        const filtered = items.filter(row => row.id !== id);
        setItems(filtered);
        recalculateSubtotal(filtered);
    };

    // const handleDeleteRow = (indexToRemove) => {
    //     const updatedItems = items.filter((_, index) => index !== indexToRemove);
    //     setItems(updatedItems);
    //     // recalculateSubtotal(updatedItems)
    // };



    useEffect(() => {
        fetchServiceData();
    }, [])

    return (
        <>
            <div className="item-table-container">
                <table className="item-table">
                    <thead>
                        <tr>
                            <th className="item-table-select-item">Items</th>
                            <th>HSN</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Discount (%)</th>
                            <th>Tax (%)</th>
                            <th>Amount</th>
                            <th className="item-table-delete">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((row) => (
                            <tr key={row.id}>
                                <td className="item-table-select-item-td">
                                    <Select
                                        options={itemsOptions}
                                        value={
                                            row.item && row.item.id
                                                ? itemsOptions.find(opt => opt.value.id === row.item.id)
                                                : row.item && row.item.title
                                                    ? { label: row.item.title, value: row.item }
                                                    : null
                                        }
                                        onChange={(option) => handleInputChange(row.id, "item", option.value)}
                                        placeholder="Select Item"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        value={row.hsn || ""}
                                        readOnly
                                        className="readonly-input"
                                        placeholder="HSN"
                                    />
                                </td>

                                <td>
                                    <input
                                        type="number"
                                        value={row.quantity}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "quantity", e.target.value)
                                        }
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Quantity"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={row.rate}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "rate", e.target.value)
                                        }
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Rate"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={row.discount}
                                        step="any"
                                        name={`discount-${row.id}`}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "discount", e.target.value)
                                        }
                                        onWheel={(e) => e.target.blur()}
                                        onBlur={(e) => {
                                            const value = parseFloat(e.target.value);
                                            if (isNaN(value) || value < 0 || value > 100) {
                                                toast.warning("Please enter a valid discount (0–100%)");
                                                handleInputChange(row.id, "discount", "");
                                            } else {
                                                handleInputChange(row.id, "discount", value.toFixed(2));
                                            }
                                        }}

                                        placeholder="Discount"
                                        min="0"
                                        max="100"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={row.tax}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "tax", e.target.value)
                                        }
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Tax"
                                        min="0"
                                        max="100"
                                    />
                                </td>
                                <td className="item-table-amount">
                                    {/* {row.amount
                                        ? parseFloat(row.amount).toFixed(2)
                                        : (
                                            (row.quantity || 0) *
                                            (row.rate || 0) *
                                            (1 - (parseFloat(row.discount) || 0) / 100) *
                                            (1 + (parseFloat(row.tax) || 0) / 100)
                                        ).toFixed(2)
                                    } */}
                                    {getRowAmount(row, true)}
                                </td>

                                <td className="item-table-delete">
                                    <button
                                        onClick={() => handleDeleteRow(row.id)}
                                        className="delete-btn"
                                    >
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button type="button" onClick={handleAddRow} className="add-row-btn">
                    Add item
                </button>
            </div>

            <div className="item-table-mobile">
                <ItemTableMobile
                    items={items}
                    setItems={setItems}
                    itemsOptions={itemsOptions}
                    showVariationModal={showVariationModal}
                    setShowVariationModal={setShowVariationModal}
                    currentVariableProduct={currentVariableProduct}
                    setCurrentVariableProduct={setCurrentVariableProduct}
                    setSelectedRowId={setSelectedRowId}
                />

            </div>
            {showVariationModal && currentVariableProduct && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>Select Variation for {currentVariableProduct.title}</h3>
                        {currentVariableProduct.variation.map(v => (
                            <div key={v.id} className="variation-item" onClick={() => {
                                const updated = items.map(row => row.id === selectedRowId ? {
                                    ...row,
                                    item: { title: `${currentVariableProduct.title} - ${v.sku}` },
                                    rate: v.salePrice
                                } : row);
                                setItems(updated);
                                recalculateSubtotal(updated);
                                setShowVariationModal(false);
                            }}>
                                <img src={`${url}${v.imageUrl}`} alt="variation" width="50" />
                                <div>
                                    <p>SKU: {v.sku}</p>
                                    <p>Price: ₹{v.salePrice}</p>
                                    <p>Stock: {v.stock}</p>
                                </div>
                            </div>
                        ))}
                        <button onClick={() => setShowVariationModal(false)}>Cancel</button>
                    </div>
                </div>
            )}

        </>
    );
};

export default ItemTable;






const ItemTableMobile = ({ items,
    setItems,
    itemsOptions,
    showVariationModal,
    setShowVariationModal,
    currentVariableProduct,
    setCurrentVariableProduct,
    setSelectedRowId }) => {
    // const [items, setItems] = useState([
    //     { id: Date.now(), item: null, quantity: "", rate: "", discount: "", tax: "", amount: 0 },
    // ]);
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [equipments, setEquipments] = useState([]);





    const calculateAmount = (quantity, rate, discount, tax, amount, editMode = false) => {
        const userEdited =
            quantity || rate || discount || tax; // ✅ detect edits

        if (!userEdited && editMode && amount !== undefined && amount !== null && amount !== "") {
            // ✅ Trust backend amount only when editing existing invoice and no fields touched
            return parseFloat(amount).toFixed(2);
        }

        // ✅ Otherwise recalc dynamically
        return (
            (parseFloat(quantity) || 0) *
            (parseFloat(rate) || 0) *
            (1 - (parseFloat(discount) || 0) / 100) *
            (1 + (parseFloat(tax) || 0) / 100)
        ).toFixed(2);
    };



    const handleInputChange = (id, field, value) => {
        if (field === "item") {
            if (value.value.product_type === "Variable Product") {
                setCurrentVariableProduct(value.value);
                setSelectedRowId(id);
                setShowVariationModal(true);
                return;
            }

            const updatedItems = items.map(item =>
                item.id === id
                    ? {
                        ...item,
                        item: value,
                         hsn: value.value.hsn || "",
                        rate: value.value.discountPrice || value.value.price || "",
                        quantity: item.quantity && parseFloat(item.quantity) > 0 ? item.quantity : "1"
                    }
                    : item
            );
            setItems(updatedItems);
            return;
        }

        const updatedItems = items.map(item =>
            item.id === id ? { ...item, [field]: value } : item
        );
        setItems(updatedItems);
    };


    const handleAddRow = () => {
        setItems([
            ...items,
            { id: Date.now(), item: null, quantity: "1", rate: "", discount: "", tax: "", amount: 0,hsn:"" },
        ]);
    };

    // const handleDeleteRow = (indexToRemove) => {
    //     const updatedItems = items.filter((_, index) => index !== indexToRemove);
    //     setItems(updatedItems);

    // };
    const handleDeleteRow = (id) => {
        const filtered = items.filter(row => row.id !== id);
        setItems(filtered);

    };

    console.log(items)

    return (
        <div className="oms-modal-form">
            {items.map((item) => (
                <div key={item.id} className="item-row">
                    <div className="oms-form-group">
                        <label htmlFor={`item-${item.id}`} className="oms-form-label">
                            Item
                        </label>
                        {/* <Select
                            options={itemsOptions}
                            // value={item.title}
                            value={
                                item.item
                                    ? {
                                        label: item.item.title,
                                        value: item.item,
                                    }
                                    : null
                            }

                         

                            onChange={(selectedOption) =>
                                handleInputChange(item.id, "item", selectedOption)
                            }
                            placeholder="Select Item"
                            id={`item-${item.id}`}
                        /> */}
                        <Select
                            options={itemsOptions}
                            value={
                                item.item?.title
                                    ? {
                                        label: item.item.title,
                                        value: item.item,
                                    }
                                    : item.item || null
                            }
                            onChange={(selectedOption) =>
                                handleInputChange(item.id, "item", selectedOption)
                            }
                            placeholder="Select Item"
                            id={`item-${item.id}`}
                        />

                    </div>
                    <div className="oms-form-group">
                        <label className="oms-form-label">
                            HSN
                        </label>
                        <input
                            type="text"
                            value={item.hsn || ""}
                            readOnly
                            className="readonly-input"
                            placeholder="HSN Code"
                        />
                    </div>

                    {/* { console.log(item.item.value.title)} */}
                    <div className="oms-form-group">
                        <label htmlFor={`quantity-${item.id}`} className="oms-form-label">
                            Quantity
                        </label>
                        <input
                            type="number"
                            id={`quantity-${item.id}`}
                            placeholder="Enter quantity"
                            value={item.quantity}
                            onChange={(e) =>
                                handleInputChange(item.id, "quantity", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`rate-${item.id}`} className="oms-form-label">
                            Rate
                        </label>
                        <input
                            type="number"
                            id={`rate-${item.id}`}
                            placeholder="Enter rate"
                            value={item.rate}
                            onChange={(e) =>
                                handleInputChange(item.id, "rate", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`discount-${item.id}`} className="oms-form-label">
                            Discount (%)
                        </label>
                        {/* <input
                            type="number"
                            id={`discount-${item.id}`}
                            name={`discount-${item.id}`}
                            placeholder="Enter discount"
                            value={item.discount}
                            // onChange={(e) =>
                            //     handleInputChange(item.id, "discount", parseFloat(e.target.value))
                            // }
                            onChange={(e) => handleInputChange(item.id, "discount", e.target.value)}

                            onBlur={(e) => {
                                const value = parseFloat(e.target.value);
                                if (isNaN(value) || value < 0 || value > 100) {
                                    toast.warning("Please enter a valid discount (0–100%)");
                                    handleInputChange(item.id, "discount", "");
                                } else {
                                    handleInputChange(item.id, "discount", value.toFixed(2));
                                }
                            }}

                            min="0"
                            max="100"
                        /> */}
                        <input
                            type="number"
                            name={`discount-${item.id}`}
                            id={`discount-${item.id}`}
                            placeholder="Enter discount"
                            value={item.discount}
                            step="any" // ✅ Allow decimal steps
                            onChange={(e) => handleInputChange(item.id, "discount", e.target.value)}
                            onBlur={(e) => {
                                const value = parseFloat(e.target.value);
                                if (isNaN(value) || value < 0 || value > 100) {
                                    toast.warning("Please enter a valid discount (0–100%)");
                                    handleInputChange(item.id, "discount", "");
                                } else {
                                    handleInputChange(item.id, "discount", parseFloat(value).toFixed(2));
                                }
                            }}
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            max="100"
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`tax-${item.id}`} className="oms-form-label">
                            Tax (%)
                        </label>
                        <input
                            type="number"
                            id={`tax-${item.id}`}
                            placeholder="Enter tax"
                            value={item.tax}
                            onChange={(e) =>
                                handleInputChange(item.id, "tax", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            max="100"
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`amount-${item.id}`} className="oms-form-label">
                            Total Amount
                        </label>
                        <input
                            type="text"
                            id={`amount-${item.id}`}
                            value={calculateAmount(item.quantity, item.rate, item.discount, item.tax, item.amount, true)}
                            readOnly
                            className="readonly-input"
                        />

                    </div>
                    <button
                        type="button"
                        onClick={() => handleDeleteRow(item.id)}
                        className="mobile-delete-row-btn"
                    >
                        <i class="fa-solid fa-trash-can"></i>  Delete item
                    </button>
                </div>
            ))}
            <button type="button" onClick={handleAddRow} className="add-row-btn">
                Add item
            </button>
        </div>
    );
};
